import React from 'react'
import Icon from './icon'
import './text.css';

class TextEditor extends React.Component {

  static defaultProps = {
    maxlines: 28
  }

  state = {
    text: this.props.text ? this.props.text :  [],
    nextText: [],
    dirty: false,
    maxlines: this.props.maxlines
  }

  canChange = (event) => {
    if (event.key==='Enter' && this.state.nextText.length === this.state.maxlines)
      event.preventDefault()
  }

  onTextChange = (event) => {
      const children = event.target.childNodes
      const array = Array.from(children);
      const nextText = array.map( node => node.textContent )
      this.setState({ nextText, dirty: true });
  }

  undo = () => {
    this.setState({ dirty: false });
  }

  save = () => {
    this.setState({ nextText: [], dirty: false });
    this.props.onSave(this.state.nextText);
  }

  renderEditTools = () => {
    return this.state.dirty ? (
      <div className="text-editor-tools">
        <Icon icon="save" clickable className="tiny square" action={this.save}/>
      </div>
    ) : '';
  }

  render() {
    const canEdit = this.props.editable
    const editable = this.props.editable ? 'editable' : '';
    const lines = this.state.text.map( line => {
      return line.length > 0 ? <div>{line}</div> : <div><br/></div>
    })
    return (
      <div className={`text-editor ${editable}`}>
        <p contentEditable={canEdit} onInput={this.onTextChange} onKeyPress={this.canChange}>
          {lines}
        </p>
        {this.renderEditTools()}
      </div>
    )
  }
}

export default TextEditor;



// WEBPACK FOOTER //
// ./src/lib/components/text.js